import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/services/common-services/common.service';
import { TemplateType } from 'src/app/shared/constants/constants';
//import { OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { CartService } from '../../../services/cart.service';
import { ShopCommonService } from 'src/app/services/shop-service/shop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Location } from '@angular/common';
import { cloneDeep, first, last } from 'lodash';
import { take, takeLast } from 'rxjs';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
@Component({
  selector: 'app-indirect-material-detail',
  templateUrl: './indirect-material-detail.component.html',
  styleUrls: ['./indirect-material-detail.component.scss'],
})
export class IndirectMaterialDetailComponent implements OnInit {
  selectedTabIndex = 0;
  productId = this.route.snapshot.paramMap.get('id');
  product: any;
  additionalInformation: any;
  baseUrl = environment.BASE_URL;
  cmsCatName: any;
  cmsSubCatName: any;
  shopBaseUrl = environment.SHOP_BASE_URL;
  receivedData: any;
  cartMap: Map<number, any> = new Map();
  companyId = sessionStorage.getItem('customercompanyId');
  responseArray: any[] = [];
  quantity: number = 1;

  addedCatNames: Set<any> = new Set();
  addedSubCatNames: Set<any> = new Set();
  addedRFQType = '';
  productItemId!: number;
  isExpanded: boolean = false;
  categories: any[] = [];
  parentCategoryName: string = '';
  parentCategoryId!: number;
  categoryName: string = '';
  productList: any[] = [];
  slickCapabilitesConfig = {
    slidesToShow: 4, // Number of slides visible at once on desktop
    slidesToScroll: 1, // Number of slides to scroll per swipe on desktop
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Autoplay speed (milliseconds)
    dots: false, // Show dots for navigation
    infinite: true, // Enable infinite scroll
    responsive: [
      {
        breakpoint: 768, // For mobile devices (adjust this value as needed)
        settings: {
          slidesToShow: 1, // Show 1 slide at a time on mobile
          slidesToScroll: 1, // Scroll 1 slide per swipe on mobile
        },
      },
    ],
  };
  constructor(
    private route: ActivatedRoute,
    private commonService: CommonService,
    private toastr: ToastrService,
    private cartService: CartService,
    private ShopCommonService: ShopCommonService,
    private location: Location,
    private router: Router,
    private gtmService: GoogleTagManagerService
  ) {
    this.route.params.subscribe((params) => {
      this.productItemId = params['id'];
      this.quantity = 1;
      this.getProductById();
      this.getProductAdditionalInformation();
    });
  }
  ngOnInit() {
    // this.cartService.cartUrl$.subscribe((data: any) => {
    //   if (data) {
    //     this.productItemId = data;
    //     this.getProductById();
    //     this.getProductAdditionalInformation();
    //   }
    // });
    // this.getProductById();
    // this.getProductAdditionalInformation();
    this.cartService.getAllCategories();
    this.getAllCategories();
    this.cartService.getAllProductIdCategoryId();
    this.getProductList();
    this.chekCartData();
  }

  // productShowCase: OwlOptions = {
  //   loop: true,
  //   autoWidth: true,
  //   mouseDrag: true,
  //   touchDrag: true,
  //   pullDrag: true,
  //   dots: false,
  //   navSpeed: 700,
  //   navText: [
  //     '<img src="assets/images/chevron-left.png" alt="right"/>',
  //     '<img src="assets/images/chevron-right.png" alt="right"/>',
  //   ],
  //   responsive: {
  //     0: {
  //       items: 1,
  //     },
  //     400: {
  //       items: 1,
  //     },
  //     740: {
  //       items: 1,
  //     },
  //     940: {
  //       items: 1,
  //     },
  //   },
  //   nav: true,
  // };

  back() {
    this.location.back();
  }

  getProductById() {
    let apiUrl = `${this.shopBaseUrl}v1/products/${this.productItemId}`;
    this.commonService.getData(apiUrl).subscribe({
      next: (data: any) => {
        this.product = data.data;
        console.log('Produ----->', this.product);
        this.pushProductEvent(this.product.id, this.product.name);
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
    });
  }
  pushProductEvent(id: number, name: string) {
    //Google tag for Product ID and Product Name
    const gtmTag = {
      event: 'product_search',
      event_category: 'Product Search',
      product_search_Id: id,
      product_search_Name: name,
    };
    this.gtmService.pushTag(gtmTag);
  }
  getAllCategories(): void {
    let apiUrl = `${this.shopBaseUrl}categories?page=1&limit=1000`;
    this.commonService.getData(apiUrl).subscribe({
      next: (data: any) => {
        this.categories = data?.data;
        if (this.cartService.productIdCategoryId.has(this.product.id)) {
          let categoryIds: any = this.cartService.productIdCategoryId.get(
            this.product.id
          );
          this.getParentCategoryName(categoryIds);
        }
        //let catItem:any = this.categories.find((item) => item.category_id == selectedId);
        //this.getParentCategoryName(catItem.parent_id);
      },
      error: (error: HttpErrorResponse) => {
        // console.log(error);
      },
    });
  }
  getParentCategoryName(categoryId: any) {
    if (categoryId && categoryId !== 1) {
      //const category = this.categories.find(cat => cat.category_id === categoryId);
      this.parentCategoryName = this.categories.find(
        (cat) => cat.category_id === first(categoryId)
      )?.name;
      this.parentCategoryId = first(categoryId);
      this.categoryName = this.categories.find(
        (cat) => cat.category_id === last(categoryId)
      )?.name;
    }
    if (categoryId === 1) {
      this.parentCategoryId = categoryId;
    }
  }
  getDescription(): string {
    if (this?.product?.description) {
      if (this.isExpanded) {
        return this.product.description;
      } else {
        const descriptionClone = cloneDeep(this.product.description);
        return descriptionClone.substring(0, 200);
      }
    }
    return '';
  }

  showReadMoreLess(): boolean {
    if (this?.product?.description.split('').length > 200) {
      return true;
    }
    return false;
  }

  toggleReadMore() {
    this.isExpanded = !this.isExpanded;
  }

  getProductAdditionalInformation() {
    let apiUrl = `${this.shopBaseUrl}v1/products/${this.productItemId}/additional-information`;
    this.commonService.getData(apiUrl).subscribe({
      next: (data: any) => {
        this.additionalInformation = data.data;

        const tempId = this.productItemId;

        if(this.additionalInformation.length !== 0){
          const erpData = this.additionalInformation.find((item: any) => item.code === 'ERP_ID');
          if (erpData) {
            let existingData = localStorage.getItem('additionalInformation');
            let data = existingData ? JSON.parse(existingData) : {};
            if (!data[tempId]) {
              data[tempId] = erpData;
              localStorage.setItem('additionalInformation', JSON.stringify(data));
            }
          }
      }
    },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
    });
  }

  getCategorySubCategory(categoryIds: number[], fromChild: boolean) {
    categoryIds?.forEach((categoryId: number) => {
      this.cartService.categories?.forEach((data: any) => {
        if (data.category_id == categoryId) {
          if (!fromChild) {
            this.addedSubCatNames.add(data.name);
            // } else if (fromChild) {
            //   this.addedCatNames.add(data.name);
          }
          if (data?.parent_id && data?.parent_id != 1) {
            this.getCategorySubCategory([data.parent_id], true);
          }
          if (data.parent_id == 1) {
            this.addedRFQType = data.name;
            this.addedCatNames.add(data.name);
          }
        }
      });
    });
  }

  getSelectedItemHierarchy(itemName: string, joinWith: string = '|') {
    const categories = new Set([
      ...this.addedCatNames,
      ...this.addedSubCatNames,
    ]);
    return [...categories].join(joinWith);
  }

  addToCart(product: any) {
    this.addedCatNames = new Set();
    this.addedSubCatNames = new Set();
    this.addedRFQType = '';
    let rfqType = '';
    if (this.cartService.productIdCategoryId.has(product.id)) {
      let categoryIds: any = this.cartService.productIdCategoryId.get(
        product.id
      );
      this.getCategorySubCategory(categoryIds, false);
    }

    if (this.addedRFQType == 'Capital Equipments') {
      rfqType = TemplateType.CapEx;
    } else if (this.addedRFQType == 'Indirect MRO') {
      rfqType = TemplateType.InDirectMRO;
    } else {
      rfqType = TemplateType.Others;
    }

    const cmsCatName = first(Array.from(this.addedCatNames));
    const cmsSubCatName = last(Array.from(this.addedSubCatNames));
    let payLoad = {
      productId: product.id,
      productName: product.name,
      quantity: this.quantity,
      date: new Date().toISOString(),
      // cmsCatName: catNames.length ? last(catNames) : last(subCatNames),
      // cmsSubCatName: last(subCatNames),
      cmsCatName: cmsCatName,
      cmsSubCatName: cmsSubCatName,
      imageUrl: product.base_image.original_image_url,
      rfqTemplate: rfqType,
      tags: this.getSelectedItemHierarchy(product.name),
    };

    let customerToken = sessionStorage.getItem('customerToken');
    if (!customerToken) {
      this.addtoStorageCart(product.id, payLoad);
    } else {
      Object.assign(payLoad, {
        companyId: this.companyId,
      });
      let apiUrl = `${this.baseUrl}rfq/cart/addCart`;
      this.commonService.postDatawithoutHeaders(apiUrl, payLoad).subscribe({
        next: (data: any) => {
          this.toastr.success('Product added to cart', '', {
            positionClass: 'toast-bottom-right',
          });
          this.cartService.getCartItems();
        },
        error: (error: HttpErrorResponse) => {
          console.log(error);
        },
      });
    }
  }

  addtoStorageCart(id: number, product: any): void {
    let cartLocalData: any = sessionStorage.getItem('cartData');
    if(cartLocalData){
      let dataItem = JSON.parse(cartLocalData);
      let cartValue = Object.values(dataItem);
      cartValue.forEach((product: any) => {
        if (this.cartMap.has(product.productId)) {
          let productItem = this.cartMap.get(product.productId);
          if(productItem.productId == id){
            productItem.quantity = productItem.quantity + 1;
          }
        } else {
          this.cartMap.set(product.productId, product);
        }
      });
    }
    if (this.cartMap.has(id) && !cartLocalData) {
      let cartItem = this.cartMap.get(id);
      cartItem.quantity = cartItem.quantity + 1;
    } else {
      this.cartMap.set(id, product);
    }
    const obj = Object.fromEntries(this.cartMap.entries());
    sessionStorage.setItem('cartData', JSON.stringify(obj));
    this.toastr.success('Product added to cart', '', {
      positionClass: 'toast-bottom-right',
    });
    this.responseArray = Object.values(obj);
    let responseObject = {
      response: this.responseArray,
    };
    this.cartService.cartUpdates.next(responseObject);
    this.cartMap.clear();
  }

  chekCartData() {
    let cartLocalData: any = sessionStorage.getItem('cartData');
    if (cartLocalData) {
      let dataItem = JSON.parse(cartLocalData);
      this.assignCartMap(dataItem);
      let responseArray = Object.values(dataItem);
      let responseObject = {
        response: responseArray,
      };
      this.cartService.cartUpdates.next(responseObject);
    }
  }

  assignCartMap(data: any) {
    let map: any = new Map(Object.entries(data));
    // Convert string keys to number keys
    let assignCartMap: any = new Map();
    map.forEach((value: any, key: string) => {
      assignCartMap.set(Number(key), value);
    });
    this.cartMap = assignCartMap;
  }

  addQuantity() {
    this.quantity += 1;
  }

  minusQuantity() {
    this.quantity -= 1;
  }
  getProductList() {
    let apiUrl = `${this.shopBaseUrl}v1/products?limit=8&page=1`;
    this.commonService.getData(apiUrl).subscribe((data) => {
      this.productList = data?.data;
    });
  }
  redirectProductDetail(productId: number, catId?: number, catName?: any) {
    this.router.navigate([`/product/${productId}`]);
  }
  getCategoryProduct(categoryId: number, categoryName: string) {
    this.router.navigate(['/products'], {
      queryParams: {
        catId: categoryId,
      },
    });
  }
}
